import { render, staticRenderFns } from "./AddPurchaseInvoiceRowMapping.vue?vue&type=template&id=2436fb46"
import script from "./AddPurchaseInvoiceRowMapping.vue?vue&type=script&lang=ts"
export * from "./AddPurchaseInvoiceRowMapping.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports